import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdiSvg",
  },
  theme: {
    themes: {
      light: {
        // color
        primary: "#57C693",
        accent: "#FFEB3B",
        dark: "#1D8455",
        light: "#d0f0dc",
        white: "#fff",
        black: "#000",
        blue: "#1e88e5",
        red: "#e83a3b",
        border: "#3A9D5D",
        text: "#1d1d1d",
        delete: "#000",
        // font
        zenMar: "Zen Maru Gothic",
        roboto: "Roboto",
      },
    },
  },
});
